import { ReactElement, useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Layout, Menu, Button } from "antd";
import { UploadOutlined, UserOutlined, DownloadOutlined } from '@ant-design/icons';

export function ShopHeaderBar(): ReactElement {
    
const dispatch = useDispatch();
const history = useHistory();
const { t } = useTranslation();
const { SubMenu } = Menu;
const { Header, Content, Footer, Sider } = Layout;

return (
    <Header className="header">
        <Menu theme="dark" mode="horizontal" style={{float:"right"}}>
            <Menu.Item key="1" onClick={()=>history.push("/shop")}>Shop</Menu.Item>
            <Menu.Item key="2" onClick={()=>history.push("/login")}>Sign In / Sign Up</Menu.Item>
        </Menu>
    </Header>
  );
}
